import Banner from "./banner/Banner";
import StockLocator from "./stock_locator/StockLocator";
import Testimonials from "./testimonials/Testimonials.js";
import Search from "./search/Search";
import Articles from "./articles/articles";
import StockLocatorDetail from "./stock_locator/views/detail/detail";
import StockLocatorSimilar from "./stock_locator/views/Similar/Similar";
import StockLocatorList from "./stock_locator/views/list/list";
import Notifications from "./notifications/notifications";
import CookieBar from "./cookies/bar/CookieBar";
import CookiePage from "./cookies/page/CookiePage";
import Filter from "./stock_locator/views/Filter/Filter";
import Rental from "./rental/rental";
import CarPark from "./rental_vehicles/views/CarPark/CarPark";
import VehicleDetail from "./rental_vehicles/views/CarPark/Detail/VehicleDetail";
import Prices from "./rental_prices/Prices";
import VehicleSimilar from "./rental_vehicles/views/similar/similar";

const Modules = {

    init() {
        CookieBar.init();
        CookiePage.init();
        Banner.init();
        StockLocator.init();
        Testimonials.init();
		Search.init();
        Articles.init();
        StockLocatorSimilar.init();
        Notifications.init();
        Rental.init();
        CarPark.init();
        VehicleDetail.init();
        Prices.init();
        VehicleSimilar.init();
    },

    resize(){
        StockLocatorDetail.resize();
        StockLocatorList.resize();
        Filter.resize();
        Banner.resize();
        CarPark.resize();
    },

    setByUrl(path, search) {
    }
}

export default Modules;